import styles from './Primitives.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Spinner = () => {
  return (
    <div className={styles.spinnerWrapper}>
      <FontAwesomeIcon icon={['fas', 'spinner']} spin className={styles.spinner} />
    </div>
  );
};
